import { telephone as telephonePattern } from "./patternHelper";

export function isValidEmail(email: string): boolean {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailPattern.test(email);
}

export function isValidTelephone(telephone: string): boolean {
  return telephonePattern.test(telephone);
}

export function isValidBookVisitTelephone(telephone: string): boolean {
  if (/^(050|070|080|090)/.test(telephone)) {
    return /^(050|070|080|090)\d{8}$/.test(telephone);
  }
  return /^\d{10}$/.test(telephone);
}

export function isValidName(name: string): boolean {
  const nameRegex = /^([^0-9!"#$%&'()*+\u3000,/:;<=>?@[\]^_`{|}~]+)$/;
  return nameRegex.test(name);
}

export function isKatakanaChar(kana: string): boolean {
  // Katakana characters are in the range [\u30A0-\u30FF]
  // and the half-width space character is \u0020
  const katakanaRegex = /^[\u30A0-\u30FF\u0020]+$/;
  return katakanaRegex.test(kana);
}
